import React from 'react';
import { useTranslation } from 'react-i18next';
import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
const IsNotSaved = _ref => {
  let {
    isNotSaved,
    save,
    paramsForUpdate,
    loading
  } = _ref;
  const {
    t
  } = useTranslation();
  return isNotSaved && /*#__PURE__*/React.createElement("div", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(SaveButton, {
    variant: "primary",
    onClick: save,
    saveParams: paramsForUpdate,
    className: "ms-auto me-3",
    disabled: loading,
    text: t('save')
  }));
};
export default IsNotSaved;